<template>
  <svg
    v-bind="$attrs"
    :width="width"
    :height="width"
    viewBox="0 0 9 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.66183 0.525391H1.36768"
      :stroke="fill"
      stroke-linecap="round"
    />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [String, Number],
    default: 9,
  },
  height: {
    type: [String, Number],
    default: 2,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
});
</script>